import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  getTeamMembersFullRequest,
  getTeamMembersFullSuccess,
  getTeamMembersFullFailure,
  selectTeamMember,
  selectThinkTool,
} from '../reducers/teamMembersFull';
import { deleteUserReset } from '../reducers/deleteUser';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* getTeamMembersFullAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;

  return yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/team`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}

function* workerGetTeamMembersFullSaga() {
  try {
    const response = yield call(getTeamMembersFullAxios);
    const state = yield select(fullState => fullState);
    const responseFromGetTeamMembersFull = response.data.data.users;

    switch (response.status) {
      case 200:
        yield put(getTeamMembersFullSuccess(responseFromGetTeamMembersFull));
        if (state.deleteUserReducer.success) {
          yield put(selectTeamMember(responseFromGetTeamMembersFull[0].userId));
          if (responseFromGetTeamMembersFull[0].thinktools.length) {
            yield put(selectThinkTool(responseFromGetTeamMembersFull[0].thinktools[0].contentId));
          }
          yield put(deleteUserReset());
        }
        break;
      case 205:
      case 206:
      case 401:
      case 500:
        yield put(getTeamMembersFullFailure(responseFromGetTeamMembersFull));
        break;
      default:
        break;
    }
  } catch (error) {
    yield put(getTeamMembersFullFailure(error));
  }
}

export function* watcherGetTeamMembersFullSaga() {
  yield takeLatest(getTeamMembersFullRequest().type, workerGetTeamMembersFullSaga);
}
